import { RoleDto } from "./RoleDto";
import { AttributeType } from 'aws-sdk/clients/cognitoidentityserviceprovider';

export class CognitoUserDto {
  id: string;
  email: string;
  username: string;
  attributes: Array<AttributeType>;
  applicationAccesses: Array<string>;
  roles: Array<RoleDto>;
}
